import { LucideIcon, Users, BookOpen, FileText, Unlock, Banknote, Shield, Mail } from 'lucide-react';

export interface FooterLink {
  name: string;
  path: string;
  icon: LucideIcon;
}

export interface FooterColumn {
  title: string;
  links: FooterLink[];
}

/** Footer's link-column data, moved out of Footer.tsx so every theme's Footer shares it. */
export const footerColumns: FooterColumn[] = [
  {
    title: 'Journal',
    links: [
      { name: 'About the Journal', path: '/about', icon: Users },
      { name: 'Editorial Board', path: '/editorial-board', icon: Users },
      { name: 'Browse Articles', path: '/articles', icon: BookOpen },
      { name: 'Archive', path: '/journal-archives', icon: BookOpen },
    ],
  },
  {
    title: 'Authors',
    links: [
      { name: 'Submit a Paper', path: '/manuscript-submission', icon: FileText },
      { name: 'Author Guidelines', path: '/for-authors', icon: FileText },
      { name: 'Open Access Policy', path: '/open-access-statement', icon: Unlock },
      { name: 'Author Charges (APC)', path: '/guidelines#author-charges-policy', icon: Banknote },
    ],
  },
  {
    title: 'Guidelines',
    links: [
      { name: 'For Reviewers', path: '/for-reviewers', icon: Shield },
      { name: 'Peer Review Policy', path: '/peer-review-policy', icon: Shield },
      { name: 'Journal Policies', path: '/guidelines', icon: FileText },
      { name: 'Contact', path: '/contact', icon: Mail },
    ],
  },
];
